import { IQueryOrderResponse } from '../types/api';
import { IProduct, IPurchasedProduct } from '../types/product';

import { getCookie, setCookieWithExpiry } from './cookies';
import { parseJSON } from './json';
import { isObject } from './typeChecks';

const customFieldsToUpsellKeys = (order: IQueryOrderResponse) => {
  const result: Record<string, number> = {};
  const custom = order.customFields;

  if (custom?.promo1 && custom.promo1 !== 'skip') {
    result[custom.promo1] = 0;
  }
  if (custom?.promo2 && custom.promo2 !== 'skip') {
    result[custom.promo2] = 1;
  }
  if (custom?.promo3 && custom.promo3 !== 'skip') {
    result[custom.promo3] = 2;
  }
  if (custom?.promo4 && custom.promo4 !== 'skip') {
    result[custom.promo4] = 3;
  }
  return result;
};

export const getPurchasedFromCookie = (): Record<string, IPurchasedProduct> => {
  const purchasedStr = getCookie('purchased');
  return parseJSON(purchasedStr);
};

export const updatePurchasedToCookie = (
  product: IProduct,
  isPurchased?: boolean,
  upsellKey?: number,
) => {
  const purchased = getPurchasedFromCookie();
  const existingPurchase = purchased?.[product?.id]
    ? purchased?.[product?.id]
    : {};
  if (window.DEBUG) {
    console.log('purchased:', JSON.stringify(purchased, null, 2));
    console.log('existingPurchase:', JSON.stringify(existingPurchase, null, 2));
  }
  const urlParams = new URLSearchParams(window.location.search);
  const orderId =
    urlParams.get('order_id') || urlParams.get('prospect_id') || '';

  const newPurchasedProduct: IPurchasedProduct = {
    ...existingPurchase,
    id: product.id,
    isPurchased: isPurchased || false,
    orderId,
  };

  if (product?.isDownsell) {
    newPurchasedProduct.isDownsell = product?.isDownsell;
  }

  if (Number.isInteger(upsellKey)) {
    newPurchasedProduct.upsellKey = upsellKey;
  } else if (product?.upsellKey) {
    newPurchasedProduct.upsellKey = product?.upsellKey;
  }

  const newPurchased = isObject(purchased)
    ? {
        ...purchased,
        [product.id]: newPurchasedProduct,
      }
    : { [product.id]: newPurchasedProduct };
  if (window.DEBUG) {
    console.log('newPurchased:', JSON.stringify(newPurchased, null, 2));
  }
  setCookieWithExpiry('purchased', newPurchased, 15);
};

export const konnektiveProductToIProduct = (
  order: IQueryOrderResponse,
): IProduct[] => {
  const productIdUpsellKeyMap = customFieldsToUpsellKeys(order);
  return order.products
    .filter(p => {
      return p.responseType.toLowerCase() === 'success';
    })
    .map(p => ({
      id: parseInt(p.productId, 10),
      mid: p.merchantId,
      sort: parseInt(p.orderItemId, 10),
      key: '',
      name: p.name,
      quantity: parseInt(p.qty, 10),
      fullPrice: parseFloat(p.price),
      finalPrice: parseFloat(p.price),
      discount: '',
      image: p.imageUrl,
      merchantTxnId: p.merchantTxnId,
      upsellKey: productIdUpsellKeyMap[p.productId],
      shippingPrice: parseFloat(p.shipping),
      currencyCode: order.currencyCode,
      currencySymbol: order.currencySymbol,
      mostPopularLabel: false,
      bestValueLabel: false,
      orderId: order.orderId,
    }))
    .sort((a, b) => a.sort - b.sort);
};
